import Form from "../form"
import FormFill from "../form-fill"
import AsyncPaymentChecks from "../async-payment-checks"
import AsyncShippingChecks from "../async-shipping-checks"
import PageLoadAnimation from "../page-load-animation"

class Checkout {
	constructor() {
		this._init()
	}
	_init() {
		this.el = document.querySelector('[data-checkout]')

		if(!this.el) {
			return
		}

		let elStart = document.querySelector('[data-checkout-start]')
		this.currStep = 0

		this.activeClass = 'details1-is-active'
		this.isCompletedClass = 'details1--checkout-step-is-done'
		this.isInProgressClass = 'details1--checkout-step-is-in-progress'
		this.elSteps = Array.from(this.el.querySelectorAll('[data-checkout-step]'))
		this.elSteps.forEach(el => el.step = new CheckoutStep(el, this))
		this.el.addEventListener('submit', (e) => {
			this.onSubmit(e)
		})

		if(elStart) {
			window.addEventListener('load',() => setTimeout(() => {
				for(let i = 0; i < Math.max(elStart.dataset.checkoutStart, 0); i++) {
					this.elSteps[i].step.onNextClick()
				}
			} , 50))
		}
	}
	setTimingOut() {
		this.timingOut = setTimeout(()=> this.timingOut = null, 200)
	}
	updateSteps(s) {
		if(this.timingOut) {
			return;
		}
		this.currStep += s
		this.setTimingOut()
		if(this.currStep >= this.elSteps.length) {
			this.currStep = this.elSteps.length
			//Submit
			this.el.classList.remove('active')
			this.el.classList.add('loading')
			this.el.querySelectorAll('input').forEach(function(el) {
				el.readOnly = true
			})
			setTimeout(this.onSubmit(), 300)
		} else {
			const prevIndex = (this.currStep - s)
			this.elSteps[prevIndex].step.setStepClass()
			setTimeout(() => { this.elSteps.forEach(el => el.step.setStepClass()) }, 300)
		}
	}
	onSubmit(e) {
		if(this.currStep < this.elSteps.length) {
			e.preventDefault()
			this.elSteps[this.currStep].step.elNext.click()
		} else if (!e) {
			this.el.submit()
			let loading = new PageLoadAnimation(false)
			loading.toggleLoading(true)
		}
	}
}

class CheckoutStep {
	constructor(el, checkout) {
		this._init(el, checkout)
	}
	_init(el, checkout) {
		this.el = el
		this.checkout = checkout
		if(!this.el) {
			return
		}

		this.id = this.el.getAttribute('data-checkout-step')
		this.elPrev = this.el.querySelector('[data-checkout-prev]')
		this.elNext = this.el.querySelector('[data-checkout-next]')

		if(this.elPrev) {
			this.elPrev.addEventListener("click", (e) => this.onPrevClick(e))
		}

		if(this.elNext) {
			if (this.elNext.getAttribute('data-checkout-next') === 'payment') {
				let payment
				if(payment = document.querySelector('[data-async-payment]')) {
					payment.manager = new AsyncPaymentChecks(el);
					this.elNext.addEventListener('click', (e) => {
						e.preventDefault()
						payment.manager.runChecks()
							.then(result => {
								this.onNextClick(e)
								// console.log(result)
							})
							.catch(error => {
								console.log("Invalid Payment Method")
								// console.log(error)
							})
					})
				}
			} else if (this.elNext.getAttribute('data-checkout-next') === 'shipping') {
				let shipping
				if(shipping = document.querySelector('[data-async-shipping]')) {
					shipping.manager = new AsyncShippingChecks(el);
					this.elNext.addEventListener('click', (e) => {
						e.preventDefault()
						shipping.manager.runChecks()
							.then(result => {
								this.onNextClick(e)
							})
							.catch(error => {
								console.log("Invalid Shipping Method")
							})
					})
				}
			} else {
				this.elNext.addEventListener("click", (e) => {
					this.onNextClick(e)
				})
			}
		}

		this.elForm = this.el.querySelector('[data-form]')

		if(!this.elForm) {
			return
		}

		this.form = new Form(this.elForm)
		this.elForm.form = this.form
		this.duplicateForm = new FormFill(this.form)

		this.setStepClass()
	}
	onPrevClick(e) {
		e.preventDefault()
		this.checkout.updateSteps(-1)
		return false
	}
	onNextClick(e = null) {
		if (e) {
			e.preventDefault()
		}
		const isValid = this.form.checkValidation()
		if (isValid) {
			this.fillDuplicate()
			this.checkout.updateSteps(1)
		}
		return false
	}
	fillDuplicate() {
		if (this.duplicateForm.isActive()) {
			this.duplicateForm.fillFields()
		}
	}
	getActiveClass() {
		return this.checkout.activeClass
	}
	getProgressClass() {
		return this.checkout.isInProgressClass
	}
	getCompletedClass() {
		return this.checkout.isCompletedClass
	}
	getCurrStep() {
		return this.checkout.currStep
	}
	setStepClass() {
		if (this.id < this.getCurrStep()) {
			this.setStepAsComplete(true)
			this.setStepAsInProgress(false)
		} else if(this.id == this.getCurrStep()) {
			this.setStepAsComplete(false)
			this.setStepAsInProgress(true)
		} else {
			this.setStepAsComplete(false)
			this.setStepAsInProgress(false)
		}
	}
	setStepAsInProgress(b) {
		this.toggleFormElements(b)
		if (b) {
			this.el.classList.add(this.getActiveClass())
			this.el.classList.add(this.getProgressClass())
		} else {
			this.el.classList.remove(this.getActiveClass())
			this.el.classList.remove(this.getProgressClass())
		}
	}
	setStepAsComplete(b) {
		if (b) {
			this.el.classList.add(this.getCompletedClass())
		} else {
			this.el.classList.remove(this.getCompletedClass())
		}
	}
	toggleFormElements(on) {
		this.form.toggleFieldsActive(on)
		if (this.elPrev) {
			this.elPrev.disabled = !on
		}
		if (this.elNext) {
			this.elNext.disabled = !on
		}
	}
}

export default Checkout
